import { LocationService } from '@analytics/shared/services/location-service';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface PatentViewCopilotContext {
    getContext(): { patent_ids: string[]; };
}

export const PatentViewCopilotContext = Symbol('PatentViewCopilotContext');

@injectable()
export class PatentViewCopilotContextImpl implements PatentViewCopilotContext {
    constructor(
        @inject(LocationService)
        private readonly _locationService: LocationService,
    ) {}

    getContext(): { patent_ids: string[]; } {
        const search = this._locationService.search;
        const params = new URLSearchParams(search);
        const patentId = params.get('patentId') || '';
        return {
            patent_ids: [patentId],
        };
    }
}
